import * as arbitrum from './arbitrum.js';
import * as avalanche from './avalanche.js';
import * as base from './base.js';
import * as bitcoin from './bitcoin.js';
import * as bsc from './bsc.js';
import * as ethereum from './ethereum.js';
import * as mantle from './mantle.js';
import * as optimism from './optimism.js';
import * as polygon from './polygon.js';
import * as solana from './solana.js';
const builtInAssetPlugins = {
    ...arbitrum,
    ...avalanche,
    ...base,
    ...bitcoin,
    ...bsc,
    ...ethereum,
    ...mantle,
    ...optimism,
    ...polygon,
    ...solana,
};
export default builtInAssetPlugins;
